import { z } from 'zod';
import { AUTH } from '../constants/app';

/**
 * 认证相关的请求校验。前端表单与后端路由共用同一份 schema，
 * 保证"前端提示"与"接口报错"不会出现两套规则。
 */

export const emailSchema = z
  .string()
  .trim()
  .min(1, '请输入邮箱')
  .max(254, '邮箱过长')
  .email('邮箱格式不正确')
  .toLowerCase();

export const passwordSchema = z
  .string()
  .min(AUTH.passwordMinLength, `密码至少 ${AUTH.passwordMinLength} 位`)
  .max(AUTH.passwordMaxLength, `密码最多 ${AUTH.passwordMaxLength} 位`);

export const registerSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  displayName: z.string().trim().min(1, '请输入昵称').max(32, '昵称最多 32 个字符').optional(),
});
export type RegisterInput = z.infer<typeof registerSchema>;

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, '请输入密码'),
});
export type LoginInput = z.infer<typeof loginSchema>;

/** 匿名设备账号：不注册即可查词与试用，之后可升级为正式账号。 */
export const anonymousLoginSchema = z.object({
  anonymous: z.literal(true),
});
export type AnonymousLoginInput = z.infer<typeof anonymousLoginSchema>;

export const logoutSchema = z
  .object({
    allDevices: z.boolean().optional(),
  })
  .optional();
export type LogoutInput = z.infer<typeof logoutSchema>;

export const authTokensSchema = z.object({
  accessToken: z.string(),
  expiresIn: z.number().int(),
});
export type AuthTokens = z.infer<typeof authTokensSchema>;
